import { memo } from 'react';

import { useMenuItems } from '../../store';
import { handleMenuItemClick, useItemText } from '../../utils';

import { competitionTracking } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

const handleClick = handleMenuItemClick('Level 2', `${competitionTracking || 'UEFA.com'} logo`);

const HomeLink = () => {
  const { trnItem } = useMenuItems();

  const text = useItemText(trnItem);

  return (
    <a
      href={trnItem?.href}
      className={styles.competitionLogo}
      aria-label={text}
      onClick={handleClick}
      onAuxClick={handleClick}
    >
      {text}
    </a>
  );
};

export default memo(HomeLink);
